import ExpoWebviewVersionModule from "./ExpoWebviewVersionModule";
import { ExpoWebviewVersionResponse } from "./types";

export function getWebviewVersion(): ExpoWebviewVersionResponse {
  return ExpoWebviewVersionModule.getWebviewVersion();
}

export * from "./types";
